import { translate } from '@/core/translations';
import { TimeFilterPresets } from '../TimeFilterControl.const';

export const useTimeFilterPresetsTitles = () => [
  { value: TimeFilterPresets.CURRENT_DAY, title: translate('incidents_page.time_control.today') },
  { value: TimeFilterPresets.CURRENT_WEEK, title: translate('incidents_page.time_control.this_week') },
  { value: TimeFilterPresets.CURRENT_MONTH, title: translate('incidents_page.time_control.this_month') },
  { value: TimeFilterPresets.CURRENT_QUARTER, title: translate('incidents_page.time_control.this_quarter') },
  { value: TimeFilterPresets.CURRENT_YEAR, title: translate('incidents_page.time_control.this_year') },
  { value: TimeFilterPresets.FUTURE, title: translate('incidents_page.time_control.future') },
  { value: TimeFilterPresets.CUSTOM_RANGE, title: translate('incidents_page.time_control.custom_range') },
];
